export const breakpoints = {
  sm: 0,
  md: 768,
  lg: 1024,
  xl: 1280,
  xxl: 1536,
};
